export const profile = {
  'profile.theClubUserProfile.title': 'The Club Kullanıcı Profili',
  'profile.theClubUserProfile.userStatus': 'Kullanıcı Durumu',
  'profile.theClubUserProfile.username': 'Kullanıcı Adı',
  'profile.theClubUserProfile.memberSince': 'Üyelik Başlangıcı',
  'profile.theClubUserProfile.sponsor': 'Sponsor',
  'profile.theClubUserProfile.referralLink': 'Referans Bağlantısı',
  'profile.theClubUserProfile.commissionModel': 'Komisyon Modeli',
  'profile.theClubUserProfile.commissionLevels': 'Komisyon Kademeleri',
  'profile.theClubUserProfile.commissionlevel': 'Kademe',
  'profile.theClubUserProfile.rank': 'Rütbe',
  'profile.theClubUserProfile.copyTooltip': 'Panoya kopyalandı!',
  'profile.theClubUserProfile.copyReferralLink': 'Referans bağlantısını kopyala',
  'profile.theClubUserProfile.userInformation': 'Kullanıcı Bilgileri',
  'profile.personalInformation.title': 'Kişisel Bilgilerim',
  'profile.personalInformation.firstName': 'Ad',
  'profile.personalInformation.lastName': 'Soyad',
  'profile.personalInformation.email': 'E-posta',
  'profile.personalInformation.phone': 'Telefon',
  'profile.personalInformation.dateOfBirth': 'Doğum Tarihi',
  'profile.personalInformation.gender': 'Cinsiyet',
  'profile.personalInformation.country': 'Ülke',
  'profile.personalInformation.address': 'Adres',
  'profile.personalInformation.city': 'Şehir',
  'profile.personalInformation.postalCode': 'Posta Kodu',
  'profile.personalInformation.edit': 'Düzenle',
  'profile.personalInformation.save': 'Kaydet',
  'profile.personalInformation.cancel': 'İptal',
  'profile.personalInformation.male': 'Erkek',
  'profile.personalInformation.female': 'Kadın',
  'profile.personalInformation.other': 'Diğer',
  'profile.personalInformation.saving': 'Kaydediliyor...',
  'profile.personalInformation.selectGender': 'Cinsiyet seçin',
  'profile.personalInformation.saveChanges': 'Değişiklikleri kaydet',
  'profile.paymentMethods.title': 'Ödeme Yöntemlerim',
  'profile.paymentMethods.cryptoWallet': 'Kripto Cüzdan',
  'profile.paymentMethods.bankAccount': 'Banka Hesabı',
  'profile.paymentMethods.network': 'Ağ',
  'profile.paymentMethods.currency': 'Para Birimi',
  'profile.paymentMethods.address': 'Adres',
  'profile.paymentMethods.accountNumber': 'Hesap Numarası',
  'profile.paymentMethods.routingNumber': 'Routing Numarası',
  'profile.paymentMethods.bankName': 'Banka Adı',
  'profile.paymentMethods.accountHolderName': 'Hesap Sahibi Adı',
  'profile.paymentMethods.swiftCode': 'SWIFT Kodu',
  'profile.paymentMethods.edit': 'Düzenle',
  'profile.paymentMethods.save': 'Kaydet',
  'profile.paymentMethods.cancel': 'İptal',
  'profile.paymentMethods.cryptoWalletHeader': 'Kripto Para Cüzdanı',
  'profile.paymentMethods.bankAccountHeader': 'Banka Hesap Bilgileri',
  'profile.paymentMethods.selectNetwork': 'Ağ seçin',
  'profile.paymentMethods.selectCurrency': 'Para birimi seçin',
  'profile.paymentMethods.walletAddressPlaceholder': 'Cüzdan adresi',
  'profile.paymentMethods.accountNumberPlaceholder': 'Hesap numarası',
  'profile.paymentMethods.bankNamePlaceholder': 'Banka adı',
  'profile.paymentMethods.accountHolderPlaceholder': 'Hesap sahibi adı',
  'profile.paymentMethods.routingNumberPlaceholder': 'Routing numarası',
  'profile.paymentMethods.swiftCodePlaceholder': 'SWIFT/BIC kodu',
  'profile.referralLink.title': 'Referans Bağlantım',
  'profile.referralLink.description': 'Aile üyelerini, arkadaşlarınızı ve meslektaşlarınızı The Club\'a davet etmek için referans bağlantınızı kullanın. Bağlantınızı kullanarak kaydolduklarında, komisyon modelinize göre kârlarından komisyon kazanırsınız.',
  'profile.referralLink.howToUse': 'Referans bağlantınızı nasıl kullanabilirsiniz:',
  'profile.referralLink.step1': 'Aşağıdaki benzersiz referans bağlantınızı kopyalayın',
  'profile.referralLink.step2': 'Yatırım ve trading ile ilgilenen tanıdıklarınızla paylaşın',
  'profile.referralLink.step3': 'Bağlantınızı kullanarak kaydolduklarında topluluğunuzun bir parçası olurlar',
  'profile.referralLink.step4': 'Komisyon yapınıza göre kârlarından komisyon kazanın',
  'profile.referralLink.yourLink': 'Referans Bağlantınız',
  'profile.referralLink.partnerLink': 'Partner Referans Bağlantısı',
  'profile.referralLink.partnerDescription': 'Bu bağlantıyı kendi referans ağını kurmak isteyen kişilerle paylaşın. Komisyon planınızı miras alacaklar.',
  'profile.referralLink.clientLink': 'Müşteri Referans Bağlantısı',
  'profile.referralLink.clientDescription': 'Bu bağlantıyı sadece yatırım yapmak isteyen kişilerle paylaşın. Referans ağları olmayacak.',
  'profile.referralLink.notAvailable': 'Referans bağlantıları hesap türünüz için mevcut değil.',
  'profile.referralLink.copyTooltip': 'Panoya kopyalandı!',
  'profile.referralLink.copyReferralLink': 'Referans bağlantısını kopyala',
  'profile.referralLink.tipsForSuccessTitle': 'Başarı İçin İpuçları:',
  'profile.referralLink.tipsForSuccessTip1': 'Bağlantınızı yatırım ve trading ile gerçekten ilgilenen kişilerle paylaşın',
  'profile.referralLink.tipsForSuccessTip2': 'The Club\'a katılmanın faydalarını ve yatırım programlarımızın nasıl çalıştığını açıklayın',
  'profile.referralLink.tipsForSuccessTip3': 'Referanslarınızın sorularını yanıtlamak ve destek sağlamak için hazır olun',
  'profile.referralLink.tipsForSuccessTip4': 'Komisyon kazançlarınızı "Kârlarım" bölümünden takip edin',
  'profile.common.loading': 'Yükleniyor...',
  'profile.common.error': 'Veri yüklenirken hata',
  'profile.common.noData': 'Veri mevcut değil',
  'profile.common.updateSuccess': 'Bilgiler başarıyla güncellendi',
  'profile.common.updateError': 'Bilgiler güncellenirken hata',
  'profile.common.defaultUser': 'Kullanıcı',
  'profile.common.defaultUsername': 'kullanıcıadı',
  'profile.common.userMustBeActive': 'Kullanıcı aktif olmalıdır',
  'profile.errorHandling.fillRequiredFields': 'Lütfen tüm zorunlu alanları doğru şekilde doldurun',
  'profile.validation.firstName': 'Ad',
  'profile.validation.lastName': 'Soyad',
  'profile.validation.country': 'Ülke',
  'profile.validation.address': 'Adres',
  'profile.validation.city': 'Şehir',
  'profile.validation.accountNumber': 'Hesap numarası',
  'profile.validation.bankName': 'Banka adı',
  'profile.validation.accountHolderName': 'Hesap sahibi adı',
  'profile.validation.routingNumber': 'Routing numarası',
  'profile.validation.swiftCode': 'SWIFT kodu',
  'profile.validation.required': 'zorunludur',
  'profile.validation.minLength': 'en az {count} karakter olmalıdır',
  'profile.validation.maxLength': 'en fazla {count} karakter olmalıdır',  
  'profile.validation.nameFormat': 'yalnızca harf, boşluk, tire ve kesme işareti içerebilir',
  'profile.validation.phoneFormat': 'Lütfen geçerli bir telefon numarası girin',
  'profile.validation.dateOfBirth': 'Geçerli bir tarih ve 18-100 yaş arasında olmalıdır',
  'profile.validation.postalCode': 'Lütfen geçerli bir posta kodu girin',
  'profile.validation.minLengthAfterSanitization': 'temizleme sonrası en az {count} karakter olmalıdır',
  'profile.validation.selectNetwork': 'Lütfen bir ağ seçin',
  'profile.validation.selectCurrency': 'Lütfen bir para birimi seçin',
  'profile.validation.walletAddressFormat': 'Cüzdan adresi yalnızca harf ve rakam içerebilir',
  'profile.validation.accountNumberFormat': 'Hesap numarası yalnızca rakam içermelidir',
  'profile.validation.bankNameFormat': 'Banka adı geçersiz karakterler içeriyor',
  'profile.validation.accountHolderFormat': 'Hesap sahibi adı yalnızca harf, boşluk, tire, kesme işareti ve nokta içerebilir',
  'profile.validation.routingNumberFormat': 'Routing numarası tam olarak 9 rakam olmalıdır',
  'profile.validation.swiftCodeFormat': 'Lütfen geçerli bir SWIFT/BIC kodu girin',
  'profile.toast.error': 'Hata',
  'profile.toast.success': 'Başarılı',
  'profile.toast.validationError': 'Doğrulama Hatası',
};
